export const TOPIC_ACTIONS = {
  SET_STATE: "topic/setState",
  GET_TOPIC: "topic/getTopic",
  GET_TOPIC_BY_ID: "topic/getTopicById",
  CREATE_TOPIC: "topic/createTopic",
  UPDATE_TOPIC: "topic/updateTopic",
  DELETE_TOPIC: "topic/deleteTopic",
};
